<template>
  <div>
    <SetGateway ref="SetGateway" v-on:setComplete="getRouterData(router.page)"></SetGateway>
    <Card shadow>
      <Drawer
        :title="changeModalTitle"
        v-model="changeModal"
        width="500"
        @on-close="changeModalClose"
        :mask-closable="true">
        <Form :model="changeForm" ref="changeForm" @submit.native.prevent :rules="changeRule" :label-width="90" label-position="right">
          <FormItem prop="name" label="名称">
            <Input v-model="changeForm.name" placeholder="填写名称" :maxlength="128" />
          </FormItem>
          <FormItem label="启用管理员状态" :label-width="100">
            <div style="float: left">
              <i-switch v-model="changeForm.admin_state_up">
                <span slot="open">是</span>
                <span slot="close">否</span>
              </i-switch>
            </div>
          </FormItem>
          <FormItem>
            <Button type="primary" @click="changeSubmit" :loading="changeLoading">提交</Button>
            <Button style="margin-left: 8px" @click="changeModal = false">取消</Button>
          </FormItem>
        </Form>
      </Drawer>
      <Row>
        <div style="float: left">
          <AllTenantSwitch ref="AllTenantSwitch" v-on:callback="getRouterData()"></AllTenantSwitch>
        </div>
        <div style="float: right;">
          <Button :style="{marginRight: '10px', marginBottom: '10px'}" icon="md-refresh" @click="getRouterData(router.page)">刷新</Button>
          <Button
            @click="formReset('changeForm'); changeModal = true; changeModalTitle = '创建路由';"
            type="primary"
            :style="{marginBottom: '10px'}"
            icon="md-add">创建路由</Button>
        </div>
      </Row>
      <Table
        highlight-row
        :loading="tableLoading"
        ref="table"
        :data="router.data"
        :columns="router.columns">
      </Table>
      <div style="margin: 10px 0; overflow: hidden;">
        <div style="float: left;">
          当前显示 {{ router.data.length }} 条记录，总共 {{ router.count }} 条记录
        </div>
        <div style="float: right;">
          <page
            :total="router.count"
            :current="router.page"
            :page-size="router.size"
            @on-change="getRouterData"></page>
        </div>
      </div>
    </Card>
  </div>
</template>

<script>
import { getPrivateCloudRouter, changePrivateCloudRouter, deletePrivateCloudRouter } from '@/api/private-cloud/router'
import { resourceIdTransName } from '@/view/private-cloud/cacheData'
import AllTenantSwitch from '@/view/private-cloud/components/allTenantSwitch'
import SetGateway from './components/set-gateway'
import moment from 'moment'

export default {
  components: {
    SetGateway,
    AllTenantSwitch,
    moment
  },
  data () {
    return {
      tableLoading: false,
      router: {
        data: [],
        columns: [
          {
            type: 'selection',
            minWidth: 60,
            align: 'center'
          },
          {
            title: '租户',
            minWidth: 120,
            align: 'center',
            key: 'project_id',
            render: (h, params) => {
              return h('span', resourceIdTransName('projects', params.row.project_id))
            }
          },
          {
            title: '路由名称',
            align: 'center',
            minWidth: 100,
            key: 'name',
            render: (h, params) => {
              return h('a', {
                on: {
                  click: () => {
                    this.$router.push({ name: 'route_detail', params: { id: params.row.id } })
                  }
                }
              }, params.row.name)
            }
          },
          {
            title: '状态',
            align: 'center',
            minWidth: 100,
            render: (h, params) => {
              let status = params.row.status
              let color = status === 'ACTIVE' ? 'success'
                : 'warning'
              let text = status === 'ACTIVE' ? '运行'
                : '异常'
              return h('Badge', {
                props: {
                  text: text,
                  status: color
                }
              })
            }
          },
          {
            title: '外部网络',
            align: 'center',
            minWidth: 100,
            render: (h, params) => {
              return h('a', {
                on: {
                  click: () => {
                    this.$router.push({ name: 'network_detail', params: { id: params.row.external_gateway_info.network_id } })
                  }
                }
              }, (params.row.external_gateway_info.network_id ? resourceIdTransName('networks', params.row.external_gateway_info.network_id) : '无'))
            }
          },
          {
            title: '管理状态',
            align: 'center',
            minWidth: 100,
            key: 'admin_state_up',
            render: (h, params) => {
              let res = '是'
              if (!params.row.admin_state_up) {
                res = '否'
              }
              return h('span', res)
            }
          },
          {
            title: '创建时间',
            align: 'center',
            minWidth: 200,
            key: 'created_at',
            render: (h, params) => {
              return h('span', params.row.created_at ? moment(params.row.created_at).format('YYYY-MM-DD HH:mm:ss') : '')
            }
          },
          {
            title: '操作',
            align: 'center',
            minWidth: 280,
            render: (h, params) => {
              let haveGateway = false
              let externalGatewayInfo = params.row.external_gateway_info
              if (externalGatewayInfo) {
                if (externalGatewayInfo.network_id) {
                  haveGateway = true
                }
              }
              let gatewayBtn
              if (haveGateway) {
                gatewayBtn = h('Poptip', {
                  style: {
                    marginRight: '5px'
                  },
                  props: {
                    transfer: true,
                    confirm: true,
                    placement: 'bottom',
                    title: '你确定要清除网关吗?'
                  },
                  on: {
                    'on-ok': () => {
                      this.$refs.SetGateway.clearGateway(params.row.id)
                    }
                  }
                }, [
                  h('Button', {
                    props: {
                      type: 'error',
                      size: 'small'
                    }
                  }, '清除网关')
                ])
              } else {
                gatewayBtn = h('Button', {
                  style: {
                    marginRight: '5px'
                  },
                  props: {
                    type: 'primary',
                    size: 'small'
                  },
                  on: {
                    click: () => {
                      this.$refs.SetGateway.openModal(params.row.id, params.row.name)
                    }
                  }
                }, '设置网关')
              }
              return h('div', [
                gatewayBtn,
                h('Button', {
                  style: {
                    marginRight: '5px'
                  },
                  props: {
                    type: 'primary',
                    size: 'small'
                  },
                  on: {
                    click: () => {
                      this.$router.push({ name: 'route_detail', params: { id: params.row.id } })
                    }
                  }
                }, '详情'),
                h('Button', {
                  style: {
                    marginRight: '5px'
                  },
                  props: {
                    type: 'warning',
                    size: 'small'
                  },
                  on: {
                    click: () => {
                      this.modifyOpen(params.row)
                    }
                  }
                }, '编辑'),
                h('Poptip', {
                  props: {
                    transfer: true,
                    confirm: true,
                    placement: 'bottom',
                    title: '你确定要删除吗?'
                  },
                  on: {
                    'on-ok': () => {
                      this.delete(params.row)
                    }
                  }
                }, [
                  h('Button', {
                    props: {
                      type: 'error',
                      size: 'small'
                    }
                  }, '删除')
                ])
              ])
            }
          }
        ],
        count: 0,
        page: 1,
        size: 10
      },
      changeModalTitle: '创建路由',
      changeModal: false,
      changeLoading: false,
      changeForm: {
        id: '',
        name: '',
        admin_state_up: true
      },
      changeRule: {
        name: [
          { required: true, message: '路由名称不能为空', trigger: 'blur' }
        ]
      },
      searchForm: {
        all_tenants: false
      },
      isAdminRole: false
    }
  },
  mounted: function () {
    this.getRouterData()
  },
  methods: {
    // 获取路由列表数据
    getRouterData (value = 1) {
      this.router.page = value
      let params = {
        page: this.router.page,
        size: this.router.size,
        all_tenants: this.$refs.AllTenantSwitch.allTenants()
      }
      this.tableLoading = true
      getPrivateCloudRouter(params).then(res => {
        this.router.data = res.data.results
        this.router.count = res.data.count
        this.tableLoading = false
      }).catch(res => {
        this.tableLoading = false
        console.log(res.response)
        if (res.request) {
          this.$Notice.error({
            title: '获取路由列表失败！',
            desc: res.request.responseText
          })
        } else {
          this.$Notice.error({
            title: '获取路由列表失败！'
          })
        }
      })
    },
    // 通用表单重置
    formReset (name) {
      this.$refs[name].resetFields()
    },
    // 提交路由编辑表单
    changeSubmit () {
      this.$refs['changeForm'].validate((valid) => {
        if (valid) {
          this.changeLoading = true
          changePrivateCloudRouter(this.changeForm, this.changeForm.id).then(res => {
            this.$Notice.success({
              title: '操作成功！'
            })
            this.getRouterData()
            this.formReset('changeForm')
            this.changeLoading = false
            this.changeModal = false
          }).catch(res => {
            this.changeLoading = false
            if (res.request) {
              this.$Notice.error({
                title: '操作失败！',
                desc: res.request.responseText
              })
            } else {
              this.$Notice.error({
                title: '操作失败！服务器无响应'
              })
            }
          })
        } else {
          this.$Notice.warning({
            title: '提交失败，请检查表单！'
          })
        }
      })
    },
    // 删除路由
    delete (row) {
      deletePrivateCloudRouter(row.id).then(res => {
        this.$Notice.success({title: '操作成功！'})
        this.getRouterData()
      }).catch(res => {
        if (res.request) {
          this.$Notice.error({
            title: '操作失败！ 错误状态码:' + res.request.status,
            desc: res.request.responseText
          })
        } else {
          this.$Notice.error({
            title: '操作失败！服务器无响应'
          })
        }
      })
    },
    // 关闭编辑表单
    changeModalClose () {
      this.formReset('changeForm')
    },
    // 打开编辑表单
    modifyOpen (row) {
      this.formReset('changeForm')
      this.changeForm.id = row.id
      this.changeForm.name = row.name
      this.changeForm.admin_state_up = row.admin_state_up
      this.changeModalTitle = '[' + row.name + '] 编辑'
      this.changeModal = true
    }
  }
}
</script>

<style>
  .ivu-poptip-body {
    text-align: left !important;
  }
</style>
